import { render, staticRenderFns } from "./MyFooter.vue?vue&type=template&id=4701c618&scoped=true&"
import script from "./MyFooter.vue?vue&type=script&lang=js&"
export * from "./MyFooter.vue?vue&type=script&lang=js&"
import style0 from "./MyFooter.vue?vue&type=style&index=0&id=4701c618&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4701c618",
  null
  
)

export default component.exports